import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useActivatedIntegration } from '../../use-activated-integration';
import { useQuickbooksEnabled } from './quickbooks/use-quickbooks-enabled';
import { useMorningEnabled } from './morning/use-morning-enabled';
import { useXeroEnabled } from './xero/use-xero-enabled';

export function useInvoiceSyncIntegrationsEnabled() {
  const isNetSuiteEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.netSuite, {
    suspense: true,
  });
  const isStripeEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.stripe, {
    suspense: true,
  });
  const isQuickBooksEnabled = useQuickbooksEnabled();
  const isMorningEnabled = useMorningEnabled();
  const isXeroEnabled = useXeroEnabled();
  const isConnactEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.connact, {
    suspense: true,
  });
  const isPaddleEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.paddle, {
    suspense: true,
  });

  const hasAnyInvoiceSyncIntegrationEnabled =
    isNetSuiteEnabled || isStripeEnabled || isQuickBooksEnabled || isMorningEnabled || isXeroEnabled || isPaddleEnabled;

  return {
    isNetSuiteEnabled,
    isStripeEnabled,
    isQuickBooksEnabled,
    isMorningEnabled,
    isXeroEnabled,
    isConnactEnabled,
    isPaddleEnabled,
    hasAnyInvoiceSyncIntegrationEnabled,
  } as const;
}
